const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));
class CustomTreeLogic {
  constructor({ contentTagSelectors }) {
    const { contentTags, contentTagsMapById, contentTagsMapByTitle, contentTagsTree } =
      contentTagSelectors;

    // Feel free to add more, currently these are the only stuff that are needed
    this.contentTags = contentTags;
    this.contentTagsMapById = contentTagsMapById;
    this.contentTagsMapByTitle = contentTagsMapByTitle;
    this.contentTagsTree = contentTagsTree;
  }

  _isLoaded() {
    return this.contentTags.length && this.contentTagsTree.length;
  }

  setupTreeMap() {
    const stack = [];
    this.currentTreeMap = {};

    stack.push(...this.currentTree);

    while (stack.length) {
      const tag = stack.shift();
      this.currentTreeMap[tag._id] = tag;
      if (tag.children) stack.push(...tag.children);
    }
  }

  setupTree(tree) {
    this.currentTree = tree;
    this.setupTreeMap();
  }

  locateTag(tagId) {
    return this.currentTreeMap[tagId];
  }

  addTag(tag, destination) {
    const baseTag = this.locateTag(this.contentTagsMapByTitle[tag]._id);
    const destinationTag = this.locateTag(this.contentTagsMapByTitle[destination]._id);

    if (!destinationTag.children) destinationTag.children = [];
    destinationTag.children.push(baseTag);
  }

  moveTag(tag, destination) {
    const baseTag = this.locateTag(this.contentTagsMapByTitle[tag]._id);
    const parentTag = this.locateTag(baseTag.parentId);
    parentTag.children = parentTag.children.filter((tag) => tag._id !== baseTag._id);

    const destinationTag = this.locateTag(this.contentTagsMapByTitle[destination]._id);
    if (!destinationTag.children) destinationTag.children = [];
    destinationTag.children.push(baseTag);
  }

  getCustomTree(config) {
    if (!config || !this._isLoaded()) return this.contentTagsTree;

    const tree = deepCopy(this.contentTagsTree);
    this.setupTree(tree);

    for (const command of config) {
      const { action, tag, destination } = command;

      switch (action) {
      // We can implement 'move' or 'replace' when needed
      case 'add':
        this.addTag(tag, destination);
        break;
      case 'move':
        this.moveTag(tag, destination);
        break;
      case 'default':
      }
    }

    return this.currentTree;
  }
}

export { CustomTreeLogic };
